/**
 * bundle-upsell.js
 * Handles Add to Cart for the bundle upsell block.
 *
 * Animation mirrors the theme's add-to-cart-button pattern:
 *   - data-added="true" set IMMEDIATELY on click (optimistic, like ProductForm.js)
 *   - Never disables the button during animation (prevents grey-out)
 *   - Resets after 2000ms so the burst animation is fully visible
 *
 * Cart drawer: dispatches a CartAddEvent-compatible 'cart:update' event after
 * a successful fetch. cart-drawer.js listens for this and calls showDialog()
 * when the <cart-drawer-component> element has the auto-open attribute.
 * Confirmed from assets/events.js: CartAddEvent.eventName = 'cart:update'.
 */

let isAdding = false;

document.addEventListener('click', async (e) => {
  const btn = e.target.closest('.bundle-upsell__atc');
  if (!btn || isAdding) return;

  const variantId = btn.dataset.bundleVariantId;
  if (!variantId) return;

  // ── Trigger animation immediately on click, before fetch ──
  isAdding = true;
  btn.dataset.added = 'true';

  // Reset after 2000ms regardless of fetch outcome
  const resetTimeout = setTimeout(() => {
    btn.removeAttribute('data-added');
    isAdding = false;
  }, 2000);

  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
    });

    if (!response.ok) {
      const err = await response.json().catch(() => ({}));
      throw new Error(err.description || 'Cart add failed');
    }

    const cart = await response.json();

    // ── Dispatch CartAddEvent-compatible event ──
    // Replicates the structure from assets/events.js CartAddEvent constructor.
    // cart-drawer.js listens for 'cart:update' and opens the drawer when
    // auto-open attribute is present on <cart-drawer-component>.
    const cartAddEvent = new CustomEvent('cart:update', {
      bubbles: true,
      detail: {
        resource: cart,
        sourceId: 'bundle-upsell',
        data: {
          source: 'bundle-upsell',
          itemCount: 1,
          variantId: String(variantId),
        },
      },
    });

    document.dispatchEvent(cartAddEvent);

  } catch (err) {
    console.error('[bundle-upsell]', err);
    clearTimeout(resetTimeout);
    btn.removeAttribute('data-added');
    isAdding = false;
  }
});